// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Zr9l","empty":"ModalGraph_empty__1wT3X"};